import './edit-warning-modal.css';

interface EditWarningModalProps {
  isOpen: boolean;
  projectName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Modal de advertencia al editar un proyecto existente
 *
 * Advierte que los cambios pueden afectar condiciones contractuales
 */
export function EditWarningModal({
  isOpen,
  projectName,
  onConfirm,
  onCancel,
}: EditWarningModalProps): JSX.Element | null {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="edit-warning-modal" onClick={(e) => e.stopPropagation()}>
        {/* Icono de advertencia */}
        <div className="warning-icon">
          ⚠️
        </div>

        {/* Título */}
        <h2 className="modal-title">
          Advertencia: Modificación de Proyecto
        </h2>

        {/* Mensaje */}
        <div className="modal-message">
          <p className="project-name-highlight">
            <strong>{projectName}</strong>
          </p>
          <p className="warning-text">
            Está a punto de modificar un proyecto existente. Los cambios pueden afectar las
            condiciones contractuales pactadas con el cliente.
          </p>
          <ul className="warning-list">
            <li>Se incrementará la versión del contrato</li>
            <li>Los cambios pueden requerir una adenda contractual</li>
            <li>Se recomienda documentar todos los cambios realizados</li>
          </ul>
          <p className="confirmation-text">
            ¿Está seguro que desea continuar?
          </p>
        </div>

        {/* Botones */}
        <div className="modal-actions">
          <button
            type="button"
            onClick={onCancel}
            className="btn-cancel"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="btn-confirm"
          >
            Entendido, continuar
          </button>
        </div>
      </div>
    </div>
  );
}
